import React, { useState } from 'react';
import { Card, CardActionArea, CardMedia, Typography, Box } from '@mui/material';
import { FiLink } from 'react-icons/fi';
import { FaDatabase } from 'react-icons/fa';
import { extractDatasetName } from '../../Popups/FileManagement/DatasetHelper';


const LinkCard = ({ link }) => {
  const { metadata_json, url, icon } = link;
  const [imageError, setImageError] = useState(false);

  // Parse metadata_json once and store the result
  let metadata_json_obj = null;
  try {
    if(!url) {
      metadata_json_obj = JSON.parse(metadata_json);
    }
  } catch (error) {
    metadata_json_obj = null;
  }

  const getDescription = () => {
    if (!url || url.length === 0) {
      if (metadata_json_obj) {
        const description = metadata_json_obj.combined;
        return description.length > 300 ? description.slice(0, 300) + "..." : description;
      }
      return null;
    } else {
      return url;
    }
  };

  let hostname = '';
  try {
    const urlObj = new URL(url);
    hostname = urlObj.hostname;
  } catch (error) {
    hostname = url;
  }

  const hasValidIcon = icon && typeof icon === 'string';

  return (
    <Card
      sx={{
        borderRadius: '16px',
        overflow: 'hidden',
        marginBottom: 2,
        marginTop: 2,
      }}
    >
      <CardActionArea
        onClick={() => {
          if (url) {
            window.open(url, '_blank');
          }
        }}
        sx={{
          display: 'flex',
          padding: '4px 4px',
          borderRadius: '20px',
          textDecoration: 'none',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        {hasValidIcon && !imageError ? (
          <CardMedia
            component="img"
            alt={`${hostname} custom icon`}
            image={icon}
            onError={() => setImageError(true)}
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              flexShrink: 0,
            }}
          />
        ) : (
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'action.selected',
            }}
          >
            {url ? <FiLink size={24} /> : <FaDatabase size={24} />}
          </Box>
        )}
        <Box
          sx={{
            ml: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            minWidth: 0, // Important for ellipsis to work
          }}
        >
          <Typography variant="subtitle1" component="div" noWrap>
            {url ? hostname : `Dataset: ${extractDatasetName(metadata_json_obj?.source_string) || 'Unknown'}`}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: url ? 'nowrap' : 'normal', // Wrap text if it's not a URL
              display: 'block',
              minWidth: 0, // Important for ellipsis to work
            }}
          >
            {getDescription()}
          </Typography>
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default LinkCard;